export default __webpack_public_path__ + "static/media/larid_logo.a87fb9ea.PNG";